export default {
  SET_COMMUNIY_UPDATES (state, communityUpates) {
    state.communityUpates = communityUpates
  },
  SET_DISS_MISSED_UPDATES (state, id) {
    state.dissMissedUpdates.push(id)
  }
}
